<div class="tenant-form">
  <p class="tenant-form__placeholder">{{ 'common.comingSoon' | translate }}</p>
</div>
